export default __webpack_public_path__ + "static/media/ad-small.5cf2a399.jpeg";